// extracted by mini-css-extract-plugin
export default {"mainCover":"insights-cover_mainCover__XMHDG","cover_section":"insights-cover_cover_section__7hPV+","coverImg":"insights-cover_coverImg__N2tVP"};